import { render, staticRenderFns } from "./add-list-pop.vue?vue&type=template&id=2e64eccd&"
import script from "./add-list-pop.vue?vue&type=script&lang=ts&"
export * from "./add-list-pop.vue?vue&type=script&lang=ts&"
import style0 from "./add-list-pop.vue?vue&type=style&index=0&id=2e64eccd&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports